import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  root: {
    width: '100%',
    minHeight: '100%',
    padding: '30px 16px',
  },
  content: {
    maxWidth: 760,
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    marginBottom: 24,
    flexWrap: 'wrap',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
  },
  subtitle: {
    marginTop: 8,
    color: theme.texts.secondary,
  },
  addButton: {
    minWidth: 210,
  },
  assistantCard: {
    border: `1px solid ${theme.borders.disabled}`,
    borderRadius: 4,
    padding: 20,
    marginBottom: 16,
  },
  assistantHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 12,
  },
  assistantTitle: {
    fontSize: '1.125rem',
    fontWeight: 600,
  },
  status: {
    fontSize: '0.8125rem',
    color: theme.texts.secondary,
  },
  steps: {
    margin: '12px 0 0',
    paddingLeft: 22,
  },
  step: {
    marginBottom: 8,
  },
  providerButton: {
    justifyContent: 'flex-start',
    padding: '12px 16px',
    textTransform: 'none',
  },
}))

export default useStyles
